/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GdasClaimsData,
  GdasProfile,
  GdasSeller,
  GdasSellersData,
  GdasTenant,
} from "../../models/gdas";
import { UserInfo } from "../../models/user";

export enum SignedInState {
  Unset = "Unset",
  SignedIn = "SignedIn",
  SignedOut = "SignedOut",
}

export const getSignInState = (state: any): SignedInState => {
  const auth = state.auth;
  if (!auth.isFetched) {
    return SignedInState.Unset;
  }

  return auth.userInfo ? SignedInState.SignedIn : SignedInState.SignedOut;
};

export const getIsUserSignedIn = (state: any): boolean => (state?.auth?.userInfo ? true : false);

export const getUser = (state: any): UserInfo | undefined => state.auth?.userInfo;

export const getGdasProfile = (state: any): GdasProfile | undefined => state.auth?.gdasProfile;

export const getAvailableTenants = (state: any): GdasTenant[] =>
  state.auth?.gdasProfile?.tenants?.availableTenants ?? [];

export const getActiveTenantId = (state: any): string | undefined =>
  state.auth?.gdasProfile?.tenants?.activeTenantId;

export const getGdasSellers = (state: any): GdasSellersData | undefined => state.auth?.gdasSellers;

export const getGdasSellersList = (state: any): GdasSeller[] =>
  state.auth?.gdasSellers?.sellers ?? [];

export const getGdasClaims = (state: any): GdasClaimsData | undefined => state.auth?.gdasClaims;

export const hasGdasData = (state: any): boolean => !!state.auth?.gdasProfile;
